"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const command_1 = require("./command");
const domainer_1 = require("./domainer");
const rxjs_1 = require("rxjs");
const immutable_1 = require("immutable");
const operators_1 = require("rxjs/operators");
command_1.Command.prototype.push = function (context) {
    context.push(this);
    return this;
};
command_1.Command.prototype.tap = function (f) {
    f(this);
    return this;
};
class UndoContext extends domainer_1.Domainer {
    constructor() {
        super();
        this.undo$ = new rxjs_1.BehaviorSubject(immutable_1.List());
        this.redo$ = new rxjs_1.BehaviorSubject(immutable_1.List());
        this.canUndo$ = new rxjs_1.BehaviorSubject(false);
        this.canRedo$ = new rxjs_1.BehaviorSubject(false);
        this.connecting(this.undo$.pipe(operators_1.map(list => list.size > 0)), this.canUndo$);
        this.connecting(this.redo$.pipe(operators_1.map(list => list.size > 0)), this.canRedo$);
    }
    popUndo() {
        const c = this.undo$.value.last(undefined);
        if (c) {
            this.undo$.next(this.undo$.value.butLast());
            this.redo$.next(this.redo$.value.push(c));
        }
        return c;
    }
    popRedo() {
        const c = this.redo$.value.last(undefined);
        if (c) {
            this.undo$.next(this.undo$.value.push(c));
            this.redo$.next(this.redo$.value.butLast());
        }
        return c;
    }
    push(c) {
        this.undo$.next(this.undo$.value.push(c));
        this.redo$.next(immutable_1.List());
        return c;
    }
}
exports.UndoContext = UndoContext;
